var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{class:_vm.getIcon(),style:({fontSize: (_vm.size + "px"), color: ("" + _vm.color)})}),_c('div',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }